import { IConfig } from '@qunhe/ktracker-types';
import { DefTypes } from '../../constants';
import ErrorParser from '../../utils/errorParser';
import logger from '../../utils/logger';
import SystemOptions from '../../utils/options';
import { processErrorData, processErrorDataV2 } from '../collector';

export let globalErrorHandler: (event: ErrorEvent) => void;

export default function globalError(opts: IConfig) {
  // reference:
  // https://developer.mozilla.org/zh-CN/docs/Web/API/GlobalEventHandlers/onerror
  // @ts-ignore
  globalErrorHandler = (event: ErrorEvent) => {
    const { message, filename, error } = event;
    const options = SystemOptions.getInstance().getOptions();

    if (options && options.debug && error) {
      logger.error('window error handler: ' + error.toString());
    }

    // 跨域问题，无法显示有效信息
    // reference:
    // tslint:disable-next-line:max-line-length
    // https://developer.mozilla.org/zh-CN/docs/Web/API/GlobalEventHandlers/onerror#%E6%B3%A8%E6%84%8F%E4%BA%8B%E9%A1%B9
    if (message.indexOf(DefTypes.INVALID_ERROR) > -1) {
      return false;
    }

    // format error stack
    if (error) {
      const { parsedStack, labels } = ErrorParser.parseStack(error, opts.maxStackDepth);
      processErrorDataV2(parsedStack, opts, labels);
    } else {
      processErrorData({ message, url: filename }, opts);
    }
  };

  window.addEventListener('error', globalErrorHandler, false);
}
